let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eJyBR")).then(() => parcelRequire('jG5dJ'));